import { Typography, CircularProgress } from "@material-ui/core";
import { Breadcrumb } from "components/breadCrumb";
import { PageTitle } from "components/pageTitle";
import React, { useEffect } from "react";
import { useParams } from "react-router";
import {
  NewDetailsImage,
  NewDetailsInfo,
  NewDetailsText,
  NewDetailsTitle,
  NewDetailsSubtitle,
  NewDetailsCategory,
} from "./newDetails.styles";
import { Wrapper } from "components/wrapper";
import { useNewsDetailsState } from "./context/news-details-context";
import { useNewsDetailsController } from "./context/news-details-controller";

export function NewDetailsPage() {
  const { newsDetails, loading, error } = useNewsDetailsState();
  const { loadNewsDetails, clearNewsDetails } = useNewsDetailsController();
  let { id } = useParams<{ id: string }>();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });

    if (id) {
      loadNewsDetails(parseInt(id));
    }

    return () => {
      clearNewsDetails();
    };
  }, [id, loadNewsDetails, clearNewsDetails]);

  if (loading) {
    return (
      <Wrapper>
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '200px' }}>
          <CircularProgress />
        </div>
      </Wrapper>
    );
  }

  if (error) {
    return (
      <Wrapper>
        <Typography color="error" variant="h6">
          {error}
        </Typography>
      </Wrapper>
    );
  }

  if (!newsDetails) {
    return (
      <Wrapper>
        <Typography variant="h6">
          Notícia não encontrada.
        </Typography>
      </Wrapper>
    );
  }

  return (
    <>
      <Breadcrumb
        items={[
          { label: "Home", href: "/" },
          { label: "Notícias", href: "/noticias" },
          { label: newsDetails.title },
        ]}
      />
      <PageTitle>NOTÍCIAS</PageTitle>
      <Wrapper>
        <NewDetailsTitle>{newsDetails.title}</NewDetailsTitle>
        <NewDetailsSubtitle>{newsDetails.subtitle}</NewDetailsSubtitle>
        <NewDetailsCategory>{newsDetails.category}</NewDetailsCategory>

        <NewDetailsInfo>
          Publicado em {new Date(newsDetails.publication).toLocaleDateString('pt-BR')}
        </NewDetailsInfo>
        {newsDetails.imageUrl && (
          <NewDetailsImage src={newsDetails.imageUrl} alt={newsDetails.title} />
        )}
        <NewDetailsText
          dangerouslySetInnerHTML={{
            __html: newsDetails.text || ''
          }}
        />
      </Wrapper>
    </>
  );
}
